import React from 'react';
import styles from './PermitFilterBtn.module.scss';
import { Tooltip } from 'antd';
import { useDispatch } from 'react-redux';
import { ReactComponent as FilterDocumentIcon } from '../../../../../resource/FilterDocumentIcon.svg';
import { changeVisiblePermitFilter } from '../../store/action';

const PermitFilterBtn = () => {
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(changeVisiblePermitFilter(true));
  };

  return (
    <Tooltip
      title="Фильтр"
      placement="topRight"
    >
      <div
        className={styles.root}
        onClick={handleClick}
      >
        <FilterDocumentIcon />
      </div>
    </Tooltip>
  );
};

export default PermitFilterBtn;
